import { render, staticRenderFns } from "./UserBillDetail.vue?vue&type=template&id=ed2edef4&scoped=true&"
import script from "./UserBillDetail.vue?vue&type=script&lang=js&"
export * from "./UserBillDetail.vue?vue&type=script&lang=js&"
import style0 from "./UserBillDetail.vue?vue&type=style&index=0&id=ed2edef4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed2edef4",
  null
  
)

export default component.exports